import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  subTitle: {
    ...getTextProperties("18px"),
  },

  priceTitle: {
    ...getTextProperties("16px"),
  },

  priceDelete: {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "13px",
    color: "#F97066",
    marginRight: "40px",
  },
  skeleton: {
    marginBottom: "32px",
  },
  priceHeader: {
    marginBottom: "24px",
  },
  priceContainer: {
    padding: "16px 20px",
    border: "1px solid #E4E7EC",
    borderRadius: "12px",
    marginBottom: "32px",
  },
  priceContainerNotShowed: {
    border: "none !important",
    padding: "0px !important",
  },

  groupHeader: {},
  groupContent: {
    marginTop: "16px",
  },

  iconMargin: {
    marginLeft: "12px",
  },
  serviceColumns: {
    backgroundColor: "#EDF5FB",
    height: "32px",
    alignItems: "center",
    borderRadius: "8px",
    marginBottom: "8px",
  },
  serviceColumn: {
    ...getTextProperties("13px"),
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  serviceRow: {
    marginBottom: "8px",
  },
  subtotal: {
    ...getTextProperties("13px"),
    fontWeight: 400,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },

  newLineContent: {
    marginTop: "20px",
  },

  button: {
    cursor: "pointer",
  },
  buttonLabel: {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "12px",
  },
  widthAuto: {
    width: "auto",
  },
  mRight12: {
    marginRight: "12px",
  },
  columnValue: {
    paddingLeft: 13,
  },
}));

export default styles;

const getTextProperties = (fontSize: string) => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize,
  color: "#465869",
});
